import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders an input field for the maximum heart rate.
 **/
export const TextFieldMaxHeartRate = ({ values, handleChange, errors, touched }) => (
    <TextField
        fullWidth
        label={t('users.fields.maxHR')}
        type="tel"
        name="maxHeartRate"
        value={values.maxHeartRate}
        error={touched.maxHeartRate && Boolean(errors.maxHeartRate)}
        helperText={touched.maxHeartRate && errors.maxHeartRate}
        onChange={handleChange}
    />
);

TextFieldMaxHeartRate.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
